(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hacienda-collection-filters"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-hacienda-filter-option]');
    if (!option) return;

    const filters = option.closest('[data-hacienda-filters]');
    if (!filters) return;

    event.preventDefault();
    const activeTags = new Set((filters.dataset.activeTags || '').split(',').filter(Boolean));
    const groupOptions = filters.querySelectorAll(`[data-filter-group="${option.dataset.filterGroup}"]`);
    const wasActive = activeTags.has(option.dataset.tagHandle);

    groupOptions.forEach((groupOption) => activeTags.delete(groupOption.dataset.tagHandle));
    if (!wasActive) activeTags.add(option.dataset.tagHandle);

    const tagPath = activeTags.size ? `/${Array.from(activeTags).join('+')}` : '';
    window.location.assign(`${filters.dataset.collectionUrl}${tagPath}#ResultsList`);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hacienda-header"] && !Shopify.designMode) return;
  try {
    
  const normalizeEmptySearch = (form) => {
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (input && input.value.trim() === '') input.value = '*';
  };

  document.addEventListener('submit', (event) => normalizeEmptySearch(event.target));

  const clearWildcardInputs = () => {
    if (window.location.pathname !== '/search' || new URLSearchParams(window.location.search).get('q') !== '*') return;
    document.querySelectorAll('form input[name="q"]').forEach((input) => {
      if (input.value === '*') input.value = '';
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clearWildcardInputs, { once: true });
  else clearWildcardInputs();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hacienda-promo-slider"] && !Shopify.designMode) return;
  try {
    
  class HaciendaPromoSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = Number(this.dataset.autoplay) || 6000;

      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));
      this.querySelector('[data-pause]')?.addEventListener('click', () => this.togglePause());
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(index) {
      if (this.slides.length < 2) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === this.index)));
      this.restart();
    }

    togglePause() {
      this.paused = !this.paused;
      const button = this.querySelector('[data-pause]');
      button?.setAttribute('aria-pressed', String(this.paused));
      button?.setAttribute('aria-label', this.paused ? 'Play promotions' : 'Pause promotions');
      this.paused ? this.stop() : this.start();
    }

    start() {
      if (this.paused || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = undefined;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('hacienda-promo-slider')) {
    customElements.define('hacienda-promo-slider', HaciendaPromoSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-search-brand-select]')) return;
    event.target.form?.requestSubmit();
  });

  const restoreSearchBrandSelection = () => {
    const select = document.querySelector('[data-search-brand-select]');
    const query = new URLSearchParams(window.location.search).get('q') || '';
    if (!select || !query.startsWith('vendor:')) return;
    const matchingOption = [...select.options].find((option) => option.value === query);
    if (matchingOption) select.value = query;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreSearchBrandSelection, { once: true });
  else restoreSearchBrandSelection();

  } catch(e) { console.error(e); }
})();
})();
